import logo from './logo.svg';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Router from './Router';
import axios from 'axios';

// export const baseURLLink = 'https://positive-backend.sumagodemo.com/';
export const baseURLLink = 'https://api2.positivemetering.ae/';
// export const baseURLLink = 'https://nodetest.positivemetering.in/';
// export const baseURLLink = 'http://127.0.0.1:8000/';
function App() {
  // axios.defaults.baseURL = 'https://positive-backend.sumagodemo.com/'
  //  axios.defaults.baseURL = 'https://nodetest.positivemetering.in/';
  // axios.defaults.baseURL = 'https://api.positivemetering.ae/'
  axios.defaults.baseURL = 'https://api2.positivemetering.ae/'
  // axios.defaults.baseURL = 'http://127.0.0.1:8000/';
   
  return (
    <>
      <Router />
    </>
  );
}

export default App;
// export const captchaKey = "6Lc9fHAqAAAAAHnziHljOuI8xEvd4VU-xTikN5Y4"  // . com
// export const captchaKey = "6LfKtTgqAAAAAGiBqsRqk3xuGrMnqfIlKQgMpT4f"  // . in
export const captchaKey = "6LdscT8qAAAAAPbFHPpVbW3vesSLNAIEqdZuB8Dq"  // . ae
// export const captchaKey = "6LevTFsqAAAAAD5gvKBNZTzNtgPHTX38UAlQdV_E" // local
// export const captchaKey = "6LfpfgwrAAAAALmozTVkrV1bGyljnlypmgf9I2zr" // demo

// for mail sending url

// export const mailUrl = "https://positivemetering.in"  // for .in and .com
export const mailUrl = "https://positivemetering.ae"